<template>
  <div class="am-endorsement-modal">
    <div v-if="loading" class="am-loading-screen-endorsement"></div>
    <div v-if="!loading && !hasError">
      <div class="am-endorsement-header">
        <span>Finance Additional Premium</span>
      </div>
      <div class="am-endorsement-body">
        <div class="form-row am-endorsement-main-table">
          <table class="am-endorsement-table">
            <tbody>
              <tr>
                <td class="am-endorsement-labels">Finance Company:</td>
                <td>{{financeContractData.financeCompany}}</td>
                <td class="am-endorsement-labels">Present Balance:</td>
                <td>{{financeContractData.presentBalance}}</td>
              </tr>
              <tr>
                <td class="am-endorsement-labels">Contract No:</td>
                <td>{{financeContractData.quoteCode}}</td>
                <td class="am-endorsement-labels">New Balance:</td>
                <td>{{financeContractData.newBalance}}</td>
              </tr>
              <tr>
                <td class="am-endorsement-labels">A/P Effective Date:</td>
                <td>{{financeContractData.effectiveDate}}</td>
                <td class="am-endorsement-labels">Finance Charges:</td>
                <td>{{financeContractData.financeCharge}}</td>
              </tr>
              <tr>
                <td class="am-endorsement-labels">A/P Quote Date:</td>
                <td>{{financeContractData.today}}</td>
                <td class="am-endorsement-labels">Remaining Payments:</td>
                <td>{{financeContractData.remainingPayments}}</td>
              </tr>
              <tr>
                <td class="am-endorsement-labels">A/P Amount:</td>
                <td>{{financeContractData.totalAdditionalPremium}}</td>
                <td class="am-endorsement-labels">New Payment Amount:</td>
                <td>{{financeContractData.newPaymentAmount}}</td>
              </tr>
              <tr>
                <td class="am-endorsement-labels">Amount Financed:</td>
                <td>{{financeContractData.amountFinanced}}</td>
                <td class="am-endorsement-labels">Next Due Date:</td>
                <td>{{financeContractData.nextDueDate}}</td>
              </tr>
              <tr>
                <td class="am-endorsement-labels">Down Payment:</td>
                <td>{{financeContractData.downPayment}}</td>
                <td class="am-endorsement-labels">Effective Date of Coverage:</td>
                <td>{{financeContractData.effectiveDateOfCoverage}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="am-endorsement-eSignature-section">
        <div v-if="hasEsignature !== 0" class="am-endorsement-eSignature">
          <input type="checkbox" :checked="isChecked" v-model="isChecked" @change="checkDisabled()"><span>eSignature</span>
        </div>
        <div v-if="isChecked">
          <div>Customer Email:
            <input type="text" v-model="customerEmail" @change="checkDisabled()" class="am-endorsement-eSignature-customer-email" :title="customerEmailTitle">
          </div>
          <div v-if="isDesignated === 1">Agent Email:
            <input type="text" v-model="quoteAgentEmail" @change="checkDisabled()" class="am-endorsement-eSignature-agent-email" :title="quoteAgentEmailTitle">
          </div>
        </div>
      </div>
      <div class="endorsement-footer">
        <button type="button" class="btn btn-secondary btn-xs" @click="closeModal()">Cancel</button>
        <button type="button" class="btn btn-primary btn-xs" :disabled="activateGenerateContract === false" @click="submit" title="Generate Contract">Generate Contract</button>
      </div>
    </div>
    <modal name="MessagePopup" classes="am-vue-modal" :clickToClose="false" :pivotY="0.3"  :adaptive="true" width="700px" height="auto" @closed="this.closeModal">
      <message-popup :confirmDelete="false" :errors="messageString" messageHeader="Error" :isError="true"/>
    </modal>
  </div>
</template>

<script>
import MessagePopup from "../MessagePopup"
import api from "@/http";
import moment from "moment";
import config from "@/config/global.config";
export default {
name: "Endorsement",
  data () {
    return {
      financeContractData: {
        masterId: '',
        financeContractId: '',
        amountFinanced: '',
        docStamps: '',
        downPayment: '',
        effectiveDate: '',
        effectiveDateOfCoverage: '',
        financeCharge: '',
        newPaymentAmount: '',
        nextDueDate: '',
        presentBalance: '',
        quoteCode: '',
        remainingPayments: '',
        totalAdditionalPremium: '',
        totalOfPayments: '',
        newBalance: '',
        today: '',
        financeCompany: '',
        customerId: '',
        policyIds: '',
        path: '',
        payee: ''
      },
      messageString: '',
      loading: false,
      hasError: false,
      activateGenerateContract: true,
      customerEmail: this.endorsementData.customerEmail,
      customerEmailTitle: "",
      quoteAgentEmail: this.endorsementData.quoteAgentEmail,
      quoteAgentEmailTitle: "",
      hasEsignature: this.endorsementData.hasEsignature,
      isChecked: false,
      isDesignated: this.endorsementData.isDesignated,
      identifier: ''
    }
  },
  components: {
    MessagePopup
  },
  mounted() {
    let self = this
    self.loading = true
    api.postRequest('customer/finance/integrated/add-endorsement', self.endorsementData).then(
        (data) => {
          if(data.data.results != null && data.data.results.AdditionPremiumInfo != null) {
            self.financeContractData.masterId = self.endorsementData.masterId
            self.financeContractData.amountFinanced = data.data.results.AdditionPremiumInfo['Amount Financed']
            self.financeContractData.docStamps = data.data.results.AdditionPremiumInfo['Doc Stamps']
            self.financeContractData.downPayment = data.data.results.AdditionPremiumInfo['Down Payment']
            self.financeContractData.effectiveDate = data.data.results.AdditionPremiumInfo['Effective Date']
            self.financeContractData.effectiveDateOfCoverage = data.data.results.AdditionPremiumInfo['Effective Date of Coverage']
            self.financeContractData.financeCharge = data.data.results.AdditionPremiumInfo['Finance Charge']
            self.financeContractData.newPaymentAmount = data.data.results.AdditionPremiumInfo['New Payment Amount']
            self.financeContractData.nextDueDate = data.data.results.AdditionPremiumInfo['Next Due Date']
            self.financeContractData.presentBalance = data.data.results.AdditionPremiumInfo['Present Balance']
            self.financeContractData.quoteCode = data.data.results.AdditionPremiumInfo['Quote Code']
            self.financeContractData.remainingPayments = data.data.results.AdditionPremiumInfo['Remaining Payments']
            self.financeContractData.totalAdditionalPremium = data.data.results.AdditionPremiumInfo['Total Additional Premium']
            self.financeContractData.totalOfPayments = data.data.results.AdditionPremiumInfo['Total of Payments']
            self.financeContractData.today = moment().format('MM/DD/YYYY')
            let newBalance = (parseFloat(self.financeContractData.presentBalance.substring(1).replace(",", "")) + parseFloat(self.financeContractData.totalAdditionalPremium.substring(1).replace(",", "")))
            self.financeContractData.newBalance = (new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'USD', minimumFractionDigits: 2 }).format(newBalance)).substring(2)
            self.financeContractData.financeCompany = self.endorsementData.financeCompany
            self.financeContractData.customerId = self.endorsementData.customerId
            self.financeContractData.policyIds = self.endorsementData.policyIds
            self.financeContractData.identifier = self.endorsementData.identifier
            self.financeContractData.payee = self.endorsementData.payee
            self.financeContractData.financeContractId = self.endorsementData.financeContractId
            self.loading = false
          }else{
            self.hasError = true
            self.messageString = data.data.message
            self.$modal.show('MessagePopup')
            self.loading = false
          }
        }
    ).catch(
        () => {
          this.loading = false
        }
    )
  },
  methods: {
    closeModal() {
      this.$store.dispatch('events/fireEvent', {name: 'endorsement-close', data: null})
    },
    submit() {
      let self = this
      self.loading = true
      api.postRequest('customer/finance/integrated/generate-endorsement-contract', self.financeContractData).then(
          (data) => {
            self.addEndorsementRecord()
            self.financeContractData.path = data.data.results.fullFilePath
            self.closeModal()
            api.postRequest('customer/finance/additional-premium/save', {
              premiumFinanceId: self.financeContractData.financeContractId,
              selectedPayee: self.financeContractData.payee,
              policyFee: 0,
              tax: 0,
              mgaFee: 0,
              amount: parseFloat(self.financeContractData.amountFinanced.substring(1).replace(",", "")),
              downPayment: parseFloat(self.financeContractData.downPayment.substring(1).replace(",", "")),
              dateFinanced: self.financeContractData.today.replace(/(\d\d)\/(\d\d)\/(\d{4})/, "$3-$1-$2"),
              selectedPolicies: self.financeContractData.policyIds,
              additionalPremium: parseFloat(self.financeContractData.totalAdditionalPremium.substring(1).replace(",", ""))
            })
            self.$store.dispatch('events/fireEvent', {
              name: 'open-contract-agreement',
              data: {
                'isChecked': self.isChecked,
                'customerId': self.financeContractData.customerId,
                'policyIds': self.financeContractData.policyIds,
                'customerEmail': self.customerEmail,
                'downPayment': (self.financeContractData.downPayment).replace('/[^0-9.]+/g', ""),
                'path': self.financeContractData.path,
                'fundingStatus' : self.financeContractData.payee === "carrier" ? "APP" : "APF",
                'entryType' : 'END',
                'amountsIfAddOn' : '',
                'recordName' : ''
              }
            })
          }
      ).catch(
          () => {
            this.loading = false
          }
      )
    },
    checkDisabled() {
      this.customerEmailTitle = this.validateEmail(this.customerEmail)
      this.quoteAgentEmailTitle = this.validateEmail(this.quoteAgentEmail)
      this.activateGenerateContract = (this.customerEmailTitle === "" && this.quoteAgentEmailTitle === "") || !this.isChecked;
    },
    validateEmail(email) {
      email = typeof email === 'undefined' ? '' : email
      let emailFormat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/
      let emailTitle = ""
      if(email === "") {
        emailTitle = "Please add an email!"
      } else if(email.search("@") === -1) {
        emailTitle = "Please add a valid email. Email missing @!"
      } else if (!email.match(emailFormat)) {
        emailTitle = "Please add a valid email!"
      }
      return emailTitle;
    },
    addEndorsementRecord() {
      let self = this
      api.post(config.applicationUrl('customerPost.php'), self.endorsementData)
    }
  },
  props: {
    endorsementData: Object
  }
}
</script>

<style scoped>
.am-endorsement-modal {
  background-color: whitesmoke;
  width: 650px;
}
.am-endorsement-header {
  height: 35px;
  background-color: #428bca;
  padding: 10px;
  top: 0;
  color: white;
  font-weight: 700;
}
.am-endorsement-main-table{
  padding: 10px;
}

.am-endorsement-table {
  width: 100%;
  margin-bottom: 15px;
  line-height: 2em;
}

.am-endorsement-labels {
  font-weight: bold;
}

.endorsement-footer {
  height: 50px;
  width:100%;
  position:relative;
  bottom: 0;
  padding: 15px;
  border-top: 1px solid #428bca;
}

.endorsement-footer button {
  margin-left: 5px;
  float: right;
}

.am-loading-screen-endorsement {
  background-color: rgba(255, 255, 255, 0.8);
  position: fixed;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  background-image: url(../../assets/spinner-anim2.gif);
  background-position: center center;
  background-repeat: no-repeat;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-size: 100px;
}

.am-endorsement-eSignature-section {
  padding: 0 0 10px 10px;
}

.am-endorsement-eSignature {
  margin-top: 10px;
}

.am-endorsement-eSignature-customer-email {
  margin-top: 10px;
  margin-left: 10px;
  width: 200px;
}

.am-endorsement-eSignature-agent-email {
  margin-top: 10px;
  margin-left: 31px;
  width: 200px;
}

.am-vue-modal {
  background-color: white;
  text-align: left;
  border-radius: 0;
  box-shadow: 0 20px 60px -2px rgba(27, 33, 58, 0.4);
  padding: 0;
}
</style>